import useIsValuePropShown from './useIsValuePropShown'

// Footnote crediting the data behind the value prop stats (the "*" on the cards).
// Gated by the same A/B treatment as the cards so the source only shows when they do.
// Rendered by the direct-match list in normal search, or at the bottom of the page
// (below the waterfall buckets) when the waterfall treatment is active.
const SearchValuePropSource: React.FC = () => {
  const showValueProp = useIsValuePropShown()

  if (!showValueProp) {
    return null
  }

  return (
    <div className="~w-full ~text-left ~mt-[21px] ~px-3">
      <p className="~font-gibson ~text-xs ~font-normal ~text-black">
        <sup>*</sup>
        Source: Thriveworks internal ARM-5, PHQ-9, and GAD-7 data
      </p>
    </div>
  )
}

export default SearchValuePropSource
